import { forwardRef, useImperativeHandle, useRef } from 'react';
import gettext from '@sdk/lang/gettext';
import useModalState from '@sdk/components/ui/modal/useModalState';
import Modal from '@sdk/components/ui/modal/Modal';
import H3 from '@sdk/components/ui/typography/H3';
import Text14 from '@sdk/components/ui/typography/Text14';
import Column from '@sdk/components/ui/spacing/Column';
import Clickable from '@sdk/components/primitives/Clickable';
import View from '@sdk/components/primitives/View';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import type { OpenCreateShiftModal } from '../onboardingChecklist.types';
import PublishShiftSvg from '../../../assets/svg/Misc/publish-shift-modal.svg';

import { Container } from './publishScheduleModal.styles';

type ForwardedAttrs = {
  open: () => void;
};

type Props = { openCreateShiftModal: OpenCreateShiftModal };

const PublishScheduleModal = forwardRef<ForwardedAttrs, Props>(({ openCreateShiftModal }, ref) => {
  const { isVisible, open, close } = useModalState();
  const config = useRef({ noDismiss: true }).current;

  useImperativeHandle(ref, () => ({
    open,
  }));

  return (
    <Modal fixed config={config} isVisible={isVisible} onDismiss={close}>
      <Container>
        <Column alignItems="center">
          <H3 pTop={20} pBottom={20}>
            {gettext('Publish shifts')}
          </H3>
          <Text14 themeColor={ThemeColorType.gray}>{gettext('No shifts to publish.')}</Text14>
          <Text14 themeColor={ThemeColorType.gray}>
            {gettext('Create shifts first, to be able to publish employee schedules.')}
          </Text14>
        </Column>
        <Column mLeft={215} alignItems="flex-start" pTop={20} pBottom={20}>
          <View>
            <PublishShiftSvg />
          </View>
        </Column>
        <Column alignItems="center">
          <Clickable
            onClick={() => {
              close();
              openCreateShiftModal();
            }}>
            <Text14 pTop={10} pBottom={10} themeColor={ThemeColorType.primary}>
              {gettext('Create shifts')}
            </Text14>
          </Clickable>
        </Column>
      </Container>
    </Modal>
  );
});

PublishScheduleModal.displayName = 'PublishScheduleModal';

export default PublishScheduleModal;
